import { createApi } from '@reduxjs/toolkit/query/react';
import { BaseQueryWithReAuth } from '../utils';
import { testCyclesEndpoints } from './endpoints/test-cycles';
import { testsEndpoints } from './endpoints/tests';

export const hesBaseQuery = BaseQueryWithReAuth({
  baseUrl: `${import.meta.env.VITE_SAT_URL}/`,
  credentials: 'same-origin',
  setHeaders: (headers) => {
    headers.set(
      'Authorization',
      `Bearer ${localStorage.getItem('accessToken') || ''}`
    );
    headers.set('X-Id-Token', localStorage.getItem('idToken') as string);
    return headers;
  }
});

const satApi = createApi({
  reducerPath: 'satApi',
  baseQuery: hesBaseQuery,
  endpoints: (builder) => ({
    ...testCyclesEndpoints(builder),
    ...testsEndpoints(builder)
  })
});

export const {
  usePrefetch,
  useGetAllTestCyclesQuery,
  useGetTestsFromCycleQuery,
  useUploadTestCylesMutation,
  useLazyDownloadTestReportQuery,
  useGetTestFromIdQuery,
  useCreateTestMutation,
  useLazyExecuteTestQuery,
  useGetTestMeterByIdQuery,
  useLazyGetTestCycleMetersQuery,
  useLazyInitiateCSVFilesGenerationQuery,
  useGetCSVFilesListViewQuery
} = satApi;

export default satApi;
